export const preventCloseIfNotKeyEventEsc = ($event) => {
  if ($event && $event.keyCode) {
    if ($event.keyCode !== 27) {
      return null
    }
  }
  return true
}

export const getExtensionFileFromUrl = (url) => {
  return url
    .split(/[#?]/)[0]
    .split('.')
    .pop()
    .trim()
}

export const formatDateToHuman = (date) => {
  if (!date) return null

  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}
